export default {
  name: 'product',

  ui: {
    top: '[js-product-top]',
    switch: '[js-product-switch]',
    features: '[js-product-features]',
  },

  componentDidMount () {
    const urlParams = new URLSearchParams(window.location.search)
    const version = urlParams.get('version')

    if (version === 'electric') {
      this.ui.switch.checked = true
      this.ui.top.classList.toggle('is-elec')
      this.ui.features.classList.toggle('is-elec')
    }

    if (this.ui.switch) {
      this.ui.switch.addEventListener('change', () => {
        this.ui.top.classList.toggle('is-elec')
        this.ui.features.classList.toggle('is-elec')
      })
    }
  },
}
